import React, { useEffect, useRef, useState } from 'react';
import styles from './GroupBy.module.css';
import CheckList from '../CheckList/CheckList';

const GroupBy = ({ columns, handleGroupBy }) => {
  const [groupColumnsValues, setGroupColumnsValues] = useState([]);
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null); // Ref za komponentu

  useEffect(() => {
    setTimeout(() => {
      const grupableColumnsList = columns.filter((item) => item.groupable);
      const valueList = [];
      grupableColumnsList.forEach((item) => {
        valueList.push({
          name: item.field,
          title: item.title,
          value: item.defaultGrouped || false,
        });
      });
      setGroupColumnsValues(valueList);
    }, 100);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log(groupColumnsValues);
    const fieldList = [];
    groupColumnsValues.map((item) => {
      if (item.value) {
        fieldList.push(item.name);
      }
      return '';
    });
    console.log('Lista stringova', fieldList);
    handleGroupBy(fieldList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupColumnsValues]);
  useEffect(() => {
    const grupableColumnsList = columns.filter((item) => item.groupable);
    const valueList = grupableColumnsList.map((item) => ({
      name: item.field,
      title: item.headerName || item.title,
      value: item.defaultGrouped || false,
    }));
    setGroupColumnsValues(valueList);

    // 👇 odmah pozovi handleGroupBy
    const initialFields = valueList
      .filter((item) => item.value)
      .map((item) => item.name);

    if (initialFields.length > 0) {
      handleGroupBy(initialFields);
    }
  }, [columns, handleGroupBy]);

  const handleOpen = () => {
    setOpen(!open);
  };
  const handleChange = (e) => {
    const updatedList = groupColumnsValues.map((item) =>
      item.name === e.target.name ? { ...item, value: e.target.checked } : item,
    );
    setGroupColumnsValues(updatedList);
  };

  // Dodajte useEffect za osluškivanje klikova van komponente
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpen(false); // Zatvaranje padajuće liste ako je klik van komponente
      }
    };

    // Dodavanje event listener-a
    document.addEventListener('mousedown', handleClickOutside);

    // Uklanjanje event listener-a kada se komponenta demontira
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const resetAll = () => {
    const resetList = groupColumnsValues.map((item) => ({
      ...item,
      value: false,
    }));
    setGroupColumnsValues(resetList);
  };
  return (
    <div className={styles.container} ref={containerRef}>
      <div className={styles.button} onClick={handleOpen}>
        <i className="fas fa-object-group" />
        <span className={styles.text}>Grupisanje</span>
      </div>
      <CheckList
        handleChange={handleChange}
        data={groupColumnsValues}
        show={open}
        resetAll={resetAll}
      />
    </div>
  );
};

export default GroupBy;
